<template>
  <b-form>
    <b-row>
      <b-col :md="3">
        <p style="float: left"> Select Date Range: </p>
        <vue-ctk-date-time-picker
          id="RangeDatePicker"
          label="Select a date range"
          v-model="range_value"
          :custom-shortcuts="custom_shortcuts"
          format="YYYY-MM-DD" :range="true" formatted="ll">
            <b-button variant="primary"
              class="m-2" size="sm">Current Month</b-button>
          </vue-ctk-date-time-picker>
      </b-col>
      <b-col :md="2" v-if="this.filterDetails">
        <label class="sr-only" for="inline-form-filter-by">Filter By</label>
        <b-form-select
          id="inline-form-filter-by"
          v-model="filter_by_model"
          :options="filter_by"
          >
        </b-form-select>
      </b-col>
      <b-col :md="2" v-if="this.filterDetails && this.show_options">
        <label class="sr-only" for="inline-form-filter-option">Filter Option</label>
        <b-form-select
          id="inline-form-filter-option"
          v-model="filter_option_model"
          :options="filter_option"
          >
        </b-form-select>
      </b-col>
      <b-col :md="3" v-if="this.filterDetails">
        <b-form-select
          v-if="this.value_dropdown"
          id="inline-form-filter-value-dropdown"
          v-model="filter_value_dropdown_model"
          :options="filter_value_dropdown_option"
          >
        </b-form-select>
        <b-form-input v-else v-model="filter_value_model" placeholder="Type to Search" />
      </b-col>
      <b-col :md="2" v-if="this.filterDetails">
        <b-button variant="primary" @click="reloadData()">Filter</b-button>
      </b-col>
    </b-row>
  </b-form>
</template>
<script>
  import axios from 'axios';
  import { fullURL } from '../../utils';
  import {round} from "lodash/math";
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
  import moment from "moment";

  const parseCategory = (value, type) => {
    if (type === "date") {
      return moment(value).format("MMM DD, YYYY");
    }
    return value;
  };

  export default {
    name: 'CategoricalFilterForm',
    components: {
      VueCtkDateTimePicker
    },

    props: {
      dashboardId: String,
      dashboard: Object,
      reportId: String,
      filterDetails: Array
    },

    data() {
      return {
        loading: false,
        limit: null,
        range_value: null,
        custom_shortcuts: [
          {
            key: 'alltime',
            label: 'All Time',
            value: () => {
              return {
                start: moment(this.dashboard.start_date),
                end: moment().startOf('day').add(1, 'days')
              }
            }
          }, {
            key: 'today',
            label: 'Today',
            value: () => {
              return {
                start: moment().startOf('day'),
                end: moment().startOf('day').add(1, 'days')
              }
            }
          },
          { key: 'thisWeek', label: 'This week', value: 'isoWeek' },
          {key: 'lastWeek', label: 'Last week', value: '-isoWeek'},
          {key: 'last7Days', label: 'Last 7 days', value: 7},
          {key: 'last30Days', label: 'Last 30 days', value: 30},
          {key: 'thisMonth', label: 'This month', value: 'month'},
          {key: 'lastMonth', label: 'Last month', value: '-month'},
          {key: 'thisYear', label: 'This year', value: 'year'},
          {key: 'lastYear', label: 'Last year', value: '-year'}
        ],
        start_date: null,
        end_date: null,
        startDate: null,
        endDate: null,
        filter_by_model: null,
        filter_by: [{text: "Filter By", value: null}],
        filter_option_model: null,
        filter_option_init: [{text: "Filter Option", value: null}],
        filter_option: [{text: "Filter Option", value: null}],
        filter_value_model: null,
        selected_filter_option: null,
        show_options: false,
        value_dropdown: false,
        filter_value_dropdown_model: null,
        filter_value_dropdown_option: []
      };
    },

    watch: {
      range_value(val) {
        const {start, end} = val;
        if (start != null && end != null) {
          this.start_date = start;
          this.end_date = end;
          this.reloadData();

        } else {
          console.log("something is not complete")
        }
      },

      filter_by_model(val) {
        this.filter_option_model = null
        console.log("selected filter", val)
        console.log("options init", this.filter_option_init)

          let options = [].concat(this.filter_option_init)

          this.filterDetails.forEach(el => {
            if (val === el.name) {
              let f_options = el.filter_options
              if (f_options.length <= 1 && f_options[0].toLowerCase() === "equal to") {
                this.show_options = false
              } else {
                this.show_options = true
                f_options.forEach(o => {
                  options.push({text: o, value: val + "_" + o})
                })
              }
              let location_vals = ["business_location", "agent_location"]
              if (location_vals.includes(val)) {
                this.filter_value_dropdown_option = this.all_locations
                this.value_dropdown = true
              } else {
                this.value_dropdown = false
              }

              if ("agent_supervisor_email" === val) {
                this.filter_value_dropdown_option = this.all_supervisor_agents
                this.value_dropdown = true
              } else {
                this.value_dropdown = false
              }
            }
          })
          this.filter_option = options
      },

      filter_option_model(val) {
        this.filter_option.forEach( e => {
          if (e.value === val) {
            this.selected_filter_option = e.text
          }
        })
      },
      filter_value_dropdown_model(val) {
        this.filter_value_model = val
        console.log("selected value", val)
      }
    },
    created() {
      console.log("filterDetails", this.filterDetails)
      this.filterDetails.forEach(element => {
        this.filter_by.push({text: element.name, value: element.name})
      })

    },
    methods: {
      filterChart() {},

      reloadData() {
                // let data = value['data'];
        this.$emit('loading', {'loading': true});
        let date_range = this.range_value;

        let start_date = null;
        let end_date = null;

        if (date_range != null) {
          start_date = date_range.start;
          end_date = date_range.end;
        }

        let request_data = "?dashboard_id=" + this.dashboardId;
        if (start_date != null && end_date != null) {
          request_data += "&start_date=" + start_date + "&end_date=" + end_date;
        }
        if (!!this.limit) {
          request_data += "&limit=" + this.limit;
        }
        if (!!this.filter_by_model) {
          request_data += "&filter_by=" + this.filter_by_model
          request_data += "&filter_option=" + this.selected_filter_option
          request_data += "&filter_value=" + this.filter_value_model
        }
        request_data += "&ignore_cache=" + true

        axios.get(
          fullURL(`/dashboards/report/${this.reportId}` + request_data)
        ).then(({data}) =>{
          console.log("Response Data: ", data);
          console.log("Response Data: ", {'text': data.title, 'value': data.id});
          // this.insight = this.processChartData(data, data.id);
          this.$emit('filter', {'data': data, 'id': data.id, 'dashboard_id': this.dashboardId});
        })
      }
    },

    computed: {
      limitOptions() {
        return [10, 20, 50, 100, 1000];
      },

      all_locations() {
        return [{text: "Select Location", value: null}, {text: "Abia", value: "Abia"},{text: "Adamawa", value: "Adamawa"},
          {text: "Akwa Ibom", value: "Akwa Ibom"},{text: "Anambra", value: "Anambra"},{text: "Bauchi", value: "Bauchi"},
          {text: "Bayelsa", value: "Bayelsa"},{text: "Benue", value: "Benue"},{text: "Borno", value: "Borno"},
          {text: "Cross River", value: "Cross River"},{text: "Delta", value: "Delta"},{text: "Ebonyi", value: "Ebonyi"},
          {text: "Edo", value: "Edo"},{text: "Ekiti", value: "Ekiti"},{text: "Enugu", value: "Enugu"},
          {text: "Gombe", value: "Gombe"},{text: "Imo", value: "Imo"},{text: "Jigawa", value: "Jigawa"},
          {text: "Kaduna", value: "Kaduna"},{text: "Kano", value: "Kano"},{text: "Katsina", value: "Katsina"},
          {text: "Kebbi", value: "Kebbi"},{text: "Kogi", value: "Kogi"},{text: "Kwara", value: "Kwara"},
          {text: "Lagos", value: "Lagos"},{text: "Nasarawa", value: "Nasarawa"},{text: "Niger", value: "Niger"},
          {text: "Ogun", value: "Ogun"},{text: "Ondo", value: "Ondo"},{text: "Osun", value: "Osun"},
          {text: "Oyo", value: "Oyo"},{text: "Plateau", value: "Plateau"},{text: "Rivers", value: "Rivers"},
          {text: "Sokoto", value: "Sokoto"},{text: "Taraba", value: "Taraba"},{text: "Yobe", value: "Yobe"},
          {text: "Zamfara", value: "Zamfara"}]



      },

      all_supervisor_agents() {
        return [{text: "Select Supervisor", value: null},
          {text: "Abdulmalik Salau<salau.abdulmalik@spaceso2o.com>", value: "salau.abdulmalik@spaceso2o.com"},
          {text: "Afeez Abdulahi<abdulaholadipupo@yahoo.com>", value: "abdulaholadipupo@yahoo.com"},
          {text: "Abidemi Olokodana<olasilemicheal@gmail.com>", value: "olasilemicheal@gmail.com"},
          {text: "Damian Eke<dameyhanemarley@yahoo.com>", value: "dameyhanemarley@yahoo.com"},
          {text: "Yemisi Olawale<olawaleyemisi1997@gmail.com>", value: "olawaleyemisi1997@gmail.com"},
          {text: "Anthonia Akingbade<akingbadetonia@gmail.com>", value: "akingbadetonia@gmail.com"},
          {text: "Israel Oderinde<oderindeisrael01@gmail.com>", value: "oderindeisrael01@gmail.com"},
          {text: "Obadiunor Stephanie<obadiunoraugustina2015@gmail.com>", value: "obadiunoraugustina2015@gmail.com"},
          {text: "Umoesen Isaac<umoesenisaac@gmail.com>", value: "umoesenisaac@gmail.com"},
          {text: "Adebisi Olusola<sholadkoncept@gmail.com>", value: "sholadkoncept@gmail.com"},
          {text: "David Adenuga<segunadenuga101061@gmail.com>", value: "segunadenuga101061@gmail.com"},
          {text: "Balogun Bisola<balogun.bisola90@gmail.com>", value: "balogun.bisola90@gmail.com"},
          {text: "Oluwatosin Atere<ateballz@yahoo.com>", value: "ateballz@yahoo.com"},
          {text: "Ighodalo Evidence<ighodaloevidenceisi@gmail.com>", value: "ighodaloevidenceisi@gmail.com"},
          {text: "Ferguson Nawane<fergusonemuobor94@gmail.com>", value: "fergusonemuobor94@gmail.com"},
          {text: "Sikiru Oladapo<dhirkolad@gmail.com>", value: "dhirkolad@gmail.com"},
          {text: "Ifeoma Ossai<ifygirl62@gmail.com>", value: "ifygirl62@gmail.com"},
          {text: "Ugochukwu Boneze<ugoboneze@gmail.com>", value: "ugoboneze@gmail.com"},
          {text: "Ahmed Rasheed<baybaybanker@yahoo.com>", value: "baybaybanker@yahoo.com"},
          {text: "Glory Nzubechukwu<glorygb1000@gmail.com>", value: "glorygb1000@gmail.com"},
          {text: "Opemipo Dosunmu<opemipo.dosunmu@gmail.com>", value: "opemipo.dosunmu@gmail.com"},
          {text: "Ibrahim Arasi<ibrahimarasi151@gmail.com>", value: "ibrahimarasi151@gmail.com"},
          {text: "Olanrewaju Aluko<alukolanre9@gmail.com>", value: "alukolanre9@gmail.com"},
          {text: "edwin iberi<edwiniberi11@gmail.com>", value: "edwiniberi11@gmail.com"},
          {text: "AWI AYODELE<ayodelemawi@gmail.com>", value: "ayodelemawi@gmail.com"}
        ]
      }
    }
  };
</script>
